import ReactDOM from 'react-dom'
import styles from './stylesModal.module.sass'

function Modal({ ...props }) {
    const {
        children,
        onClose,
        type,
        title,
        closeBody
    } = props

    return (
        closeBody !== 'closeBody' && 
        closeBody !== 'closeBodyBtn' && 
        closeBody !== 'backBodyBtn' && 
        closeBody !== 'modalSinHeader' && 
        closeBody !== 'modalSinHeaderBtn' && 
        closeBody !== 'search'
            ?
                <div className={`${styles?.modal} ${styles[type]}`}>
                    <div className={closeBody === 'modalAddCartMobile' ? `${styles?.contentModal} ${styles?.contentModalAddCart}` : `${styles?.contentModal}`} >
                        {type === 'fullHeader'
                            ? <div className={styles?.contentCloseAN2}>
                                    <div className={`${styles?.btn} ${styles?.closeAN2}`} onClick={onClose} aria-hidden />
                                    {title ? <p className={`${styles?.title} ${styles?.centrar}`}>{title}</p> : null}
                                </div>
                            : null
                        }
                        <div className={styles?.dataModal}>
                            {children}
                        </div>
                    </div>
                </div>

            : closeBody === 'closeBodyBtn'
                ?
                    <div className={`${styles?.modal} ${styles?.[type]}`} >
                        <span className={styles?.closeModalBody} onClick={onClose} aria-hidden />
                        <div className={styles?.contentModal}>
                            {type === 'fullHeader'
                                ? <div className={styles?.contentCloseCerrar}>
                                    <div className={`${styles?.btn} ${styles?.closeCerrar}`} onClick={onClose} aria-hidden />
                                    {title ? <p className={styles?.title}>{title}</p> : null}
                                </div>
                                : null
                            }
                            <div className={styles?.dataModal}>
                                {children}
                            </div>
                        </div>
                    </div>

            : closeBody === 'backBodyBtn'
                ?
                    <div className={`${styles?.modal} ${styles?.[type]}`} >
                        <div className={styles?.contentModal}>
                            {type === 'fullHeader'
                                ? <div className={styles?.contentCloseAN}>
                                    <div className={`${styles?.btn} ${styles?.closeBackSpe}`} onClick={onClose} aria-hidden />
                                    {title ? <p className={`${styles?.title} ${styles?.pCloseBack}`}>{title}</p> : null}
                                </div>
                                : null
                            }
                            <div className={styles?.dataModal}>
                                {children}
                            </div>
                        </div>
                    </div>

            : closeBody === 'modalSinHeader'
                ?
                    <div className={`${styles?.modal} ${styles?.[type]}`} >
                        <div className={styles?.contentModal}>
                            {type === 'fullHeader'
                                ? <div className={styles?.contentClose}>
                                    {title ? <p className={`${styles?.title} ${styles?.pCloseBack}`}>{title}</p> : null}
                                </div>
                                : null
                            }
                            <div className={styles?.dataModal}>
                                {children}
                            </div>
                        </div>
                    </div>

            : closeBody === 'modalSinHeaderBtn'
                ?
                    <div className={`${styles?.modal} ${styles?.[type]}`} >
                        <div className={styles?.contentModal}>
                            {type === 'fullHeader'
                                ? <div className={styles?.contentCloseCerrarLite}>
                                    <div className={`${styles?.btn} ${styles?.closeCerrar}`} onClick={onClose} aria-hidden />
                                </div>
                                : null
                            }
                            <div className={styles?.dataModal}>
                                {children}
                            </div>
                        </div>
                    </div>
            
            : closeBody === 'search' 
                ?
                    <div className={`${styles?.modal} ${styles?.[type]}`} onClick={onClose} aria-hidden>
                        <div className={styles?.contentModal}>
                            <div className={styles?.dataModal}>
                                {children}
                            </div>
                        </div>
                    </div>
            
            :
                <div className={`${styles?.modal} ${styles?.[type]}`} onClick={onClose} aria-hidden>
                    <div className={styles?.contentModal}>
                        {type === 'fullHeader'
                            ?
                                <div className={styles?.contentCloseCerrar}>
                                    <div className={`${styles?.btn} ${styles?.closeCerrar}`} onClick={onClose} aria-hidden />
                                    {title ? <p className={styles?.title}>{title}</p> : null}
                                </div>
                            : null
                        }
                        <div className={styles?.dataModal}>
                            {children}
                        </div>
                    </div>
                </div>

    )
}

export default function ModalPortal({ ...props }) {
    const {
        children,
        onClose,
        type,
        closeBody,
        title,
        isMobile
    } = props

    return ReactDOM.createPortal(
        <Modal onClose={onClose} type={type} title={title} closeBody={closeBody} isMobile={isMobile}>
            {children}
        </Modal>,
        document.getElementById('modal-root')
    )
}